import React from "react"

import Box from "@mui/material/Box"
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import Typography from "@mui/material/Typography"

function SimpleDashboardCard({ label, value, subtitle, endAddornment }) {
    return (
        <Card sx={{ borderRadius: 1, boxShadow: 1, height: "100%" }}>
            <CardContent>
                <Box display="flex" justifyContent="space-between">
                    <Box>
                        <Typography
                            variant="subtitle2"
                            color="text.secondary"
                            gutterBottom
                        >
                            {label}
                        </Typography>

                        <Typography variant="h5" color="text.primary">
                            {value}
                        </Typography>

                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ ml: 0.5 }}
                            whiteSpace="nowrap"
                        >
                            {subtitle}
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            mt: 1,
                        }}
                    >
                        {endAddornment}
                    </Box>
                </Box>
            </CardContent>
        </Card>
    )
}

export default SimpleDashboardCard
